import React from 'react';
import { handleGAEvents } from '../../adapters/helpers/Utils';

interface ButtonContentFields {
  contentType?: string;
  ctaName?: string;
  ctaUrl?: string;
  anchorId?: string;
  gaEventCategory?: string;
  gaEventAction?: string;
  gaEventLabel?: string;
}

interface ArticleCTAProps {
  buttonContent?: {
    fields?: ButtonContentFields;
  };
}

const ArticleCTA: React.FC<ArticleCTAProps> = ({ buttonContent }) => {
  const gaEventCategory = buttonContent?.fields?.gaEventCategory || '';
  const gaEventAction = buttonContent?.fields?.gaEventAction || '';
  const gaEventLabel = buttonContent?.fields?.gaEventLabel || '';
  
  const handleButtonClick = () => {
    handleGAEvents(gaEventCategory, gaEventAction, gaEventLabel);
    if (buttonContent?.fields?.ctaUrl) {
      const url = buttonContent?.fields?.ctaUrl;
      window.open(url, '_blank');
    }
  };

  return (
    <div id={buttonContent?.fields?.anchorId}>
      <p className="my-3">
        {buttonContent?.fields?.ctaName && (
          <button
            className="mx-auto flex items-center justify-center rounded-full bg-revamp_blueText px-5 py-1 font-semi-bold text-base text-white transition duration-300 ease-in-out hover:bg-revamp_product_bg_hover hover:no-underline focus:outline-none lg:m-0"
            onClick={handleButtonClick}
          >
            {buttonContent?.fields?.ctaName}
          </button>
        )}
      </p>
    </div>
  );
};

export default ArticleCTA;